(function() {
    'use strict';
    angular
        .module('emarket.commons')
        .controller('SellerContactDialogController', ['$timeout', '$log', '$scope', '$state', '$mdDialog', '$auth', 'ChatDialog', 'seller', function($timeout,
            $log,
            $scope,
            $state,
            $mdDialog,
            $auth,
            ChatDialog,
            seller) {
            var vm = this;
            vm.seller = seller;
            vm.isAuthenticated = $auth.isAuthenticated();

            vm.close = function() {
                $mdDialog.hide();
            };
            vm.showChatDialog = function(ev) {
                if (vm.isAuthenticated) {
                    var sellerId = seller._id || seller;
                    $timeout(function() {
                        ChatDialog.show(ev, sellerId);
                    }, 500);
                } else {
                    var confirm = $mdDialog
                        .confirm()
                        .title('Debes de Iniciar Sesión')
                        .textContent('Para poder enviar mensajes debes acceder con tu cuenta')
                        .ariaLabel('Lucky day')
                        .ok('Acceder')
                        .cancel('Cancelar');
                    $mdDialog.show(confirm).then(function() {
                        $state.go('auth');
                    });
                }
            };
        }]);
}());
